(function () {
    'use strict';

    angular.module('swif.interventions')
    .constant('swifInterventionsConstant', {
        request: {
            content_type: 'intervention_request',
            routes: {
                table_view: '/interventions/requests/table_view',
                explorer_view: '/interventions/requests/explorer_view',
                planning_view: '/interventions/requests/planning_view',
                documentation_view: '/interventions/requests/documentation_view',
                commission_view: '/interventions/requests/commission_view'
            },
            vocabularies: {
                partner_address: {
                    domain: [['partner_id.customer', '=', true]]
                },
                partner: true,
                site: true,
                department: true,
                equipment: true
            }
        },
        intervention: {
            content_type: 'intervention',
            routes: {
                table_view: '/interventions/interventions/table_view',
                leaflet_view: '/interventions/interventions/leaflet_view',
                explorer_view: '/interventions/interventions/explorer_view',
                planning_view: '/interventions/interventions/planning_view',
                documentation_view: '/interventions/interventions/documentation_view'
            },
            vocabularies: {
                domain: [['technical', '=', true]]
            }
        },
        task: {
            content_type: 'task',
            routes: {
                table_view: '/interventions/tasks/table_view',
                explorer_view: '/interventions/tasks/explorer_view',
                planning_view: '/interventions/tasks/planning_view',
                documentation_view: '/interventions/tasks/documentation_view',
                statistics_view: '/interventions/tasks/statistics_view',
                barcode_view: '/interventions/tasks/barcode_view'
            },
            vocabularies: {
                intervention: true, /*{
                    query: {
                        'filters[0][field]': 'state',
                        'filters[0][operator]': 'in',
                        'filters[0][value][]': ['open', 'scheduled', 'cancelled']
                    }
                },*/
                partner: true,
                user: true,
                department: true,
                equipment: true,
                task_category: true
            }
        }
    });

})();
